var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"width":750 - 128,"name":"scan-qr-modal"}},[_c('div',{staticClass:"modal-content"},[_c('h1',{staticClass:"text-gray"},[_vm._v("Scan QR code")]),_c('QRReader',{on:{"data":_vm.scan,"init":_vm.fixSafariBug}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }